export default __webpack_public_path__ + "static/media/back.135dd71b.svg";